<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <template v-for="item in navItems" :key="item.label">
      <template v-if="item.children?.length">
        <div class="edu-side-group-label">{{ item.label }}</div>
        <VaSidebarItem
          v-for="child in item.children"
          :key="child.type"
          :to="{ name: 'education-programs', query: { type: child.type } }"
          :active="isProgramTypeActive(child.type)"
          :active-color="activeColor"
          :text-color="isProgramTypeActive(child.type) ? 'primary' : 'textPrimary'"
          :aria-label="child.label"
          role="button"
          hover-opacity="0.10"
        >
          <VaSidebarItemContent class="py-3 pe-2 ps-8">
            <VaSidebarItemTitle class="leading-5 font-semibold">
              {{ child.label }}
            </VaSidebarItemTitle>
          </VaSidebarItemContent>
        </VaSidebarItem>
      </template>
      <VaSidebarItem
        v-else-if="item.name"
        :to="{ name: item.name }"
        :active="route.name === item.name"
        :active-color="activeColor"
        :text-color="route.name === item.name ? 'primary' : 'textPrimary'"
        :aria-label="item.label"
        role="button"
        hover-opacity="0.10"
      >
        <VaSidebarItemContent class="py-3 pe-2 ps-4">
          <VaSidebarItemTitle class="leading-5 font-semibold">
            {{ item.label }}
          </VaSidebarItemTitle>
        </VaSidebarItemContent>
      </VaSidebarItem>
    </template>
  </VaSidebar>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useColors } from 'vuestic-ui'

const navItems = [
  { name: 'education-home', label: '首页' },
  {
    label: '项目',
    children: [
      { type: 'masters', label: '硕士项目' },
      { type: 'doctoral', label: '博士项目' },
      { type: 'pathway', label: '硕博连读' },
    ],
  },
  { name: 'education-university', label: '大学认证' },
  { name: 'education-how-it-works', label: '申请流程' },
  { name: 'education-faq', label: '常见问题' },
  { name: 'education-contact', label: '咨询' },
]

export default defineComponent({
  name: 'EducationSidebar',
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible'],

  setup(props, { emit }) {
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
    const color = computed(() => getColor('background-secondary'))
    const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))

    function isProgramTypeActive(type: string) {
      return route.name === 'education-programs' && String(route.query.type || '') === type
    }

    return {
      writableVisible,
      sidebarWidth,
      color,
      activeColor,
      navItems,
      route,
      isProgramTypeActive,
    }
  },
})
</script>

<style scoped>
.edu-side-group-label {
  padding: 0.85rem 1rem 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #64748b;
  text-transform: none;
}
</style>
